// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NotFound.css */
.not-found-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: #fff;
    font-family: 'Arial', sans-serif;
  }
  
  .not-found-content {
    text-align: center;
    animation: fadeIn 1s ease-in-out;
  }
  
  .not-found-title {
    font-size: 6rem;
    margin: 0;
    font-weight: bold;
  }
  
  .not-found-message {
    font-size: 1.5rem;
    margin: 1rem 0;
  }
  
  .not-found-link {
    display: inline-block;
    padding: 0.75rem 1.5rem;
    color: #764ba2;
    background-color: #fff;
    border-radius: 5px;
    text-decoration: none;
    font-weight: bold;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .not-found-link:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }
  
  /* Add a fade-in animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Pages/NotFound/notfound.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,qDAAqD;IACrD,WAAW;IACX,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;IACvB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,qDAAqD;EACvD;;EAEA;IACE,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA,4BAA4B;EAC5B;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF","sourcesContent":["/* NotFound.css */\n.not-found-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background: linear-gradient(135deg, #667eea, #764ba2);\n    color: #fff;\n    font-family: 'Arial', sans-serif;\n  }\n  \n  .not-found-content {\n    text-align: center;\n    animation: fadeIn 1s ease-in-out;\n  }\n  \n  .not-found-title {\n    font-size: 6rem;\n    margin: 0;\n    font-weight: bold;\n  }\n  \n  .not-found-message {\n    font-size: 1.5rem;\n    margin: 1rem 0;\n  }\n  \n  .not-found-link {\n    display: inline-block;\n    padding: 0.75rem 1.5rem;\n    color: #764ba2;\n    background-color: #fff;\n    border-radius: 5px;\n    text-decoration: none;\n    font-weight: bold;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .not-found-link:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n  }\n  \n  /* Add a fade-in animation */\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(-20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
